module.exports = __webpack_public_path__ + "static/media/gmail-first-email-correct.398bf0fa.png";